export const SET_SYSTEM = 'set system payload from post message'



// WEBPACK FOOTER //
// ./redux/model/system/action.js